// import { FocusHandler } from "../../focus_handlers";
import NodeHelper from "../../helpers/node_helper";
// import NodeHandler from "../../node_handler";
import AbstractField from "./abstract";


// function search_substring(a, b){
//     // a = a.toLowerCase()
//     // b = b.toLowerCase()
//     // a.includes(b)
//     // const reg = b.split()
//     return a.match(reg)
// }

function _cast(value){
    if(value == 'false'){
        value = false
    }else if (value == 'true'){
        value = true
    }else if (value == 'null'){
        value = null
    }
    return value
}

class SelectField extends AbstractField{
    __init_dom_schema(){
        return {
            wrapper: {
                selector: '.js-form-field__wrapper',
                actions: {
                    'click': this.onToggle.bind(this)
                }
            },
            title_input: {
                selector: 'input.js-select-title',
                actions: {
                    'input': this.searchItems.bind(this),
                }
            },
            title: 'div.js-select-title',
            select: 'select',
            slide: '.js-select-slide',
            list: '.js-select-list',
        }
    }
    __init(){
        this.items = []

        if(this.options.searchable){
            this.node.classList.add('is--searchable')
        }
        this.setTitleFromSelect();
        this.registerEvents('changed')
        this.initOptions()

        this.setValue(this.dom.select.value)
    }
    prepareOptionLabel(option_content){
        const arr = option_content.split('##')
        let html = option_content
        let label = option_content
        let description = ''
        if(arr.length > 1){
            label = arr[0]
            description = arr[1]
            html = `
            <div class="js-select-item__description-inner">
                <span>
                    ${label}
                </span>
                <span class="js-select-item__description">
                    ${description}
                </span>
            </div>`
        }
        return {
            label: label,
            description: description,
            html: html,
        }
    }
    initOptions(){
        for(const dom_option of this.dom.select.querySelectorAll('option')){

            const dom_item = document.createElement('div')

            const {
                html: option_label_html, 
                label: option_label,
                description: option_description,
            } = this.prepareOptionLabel(dom_option.innerHTML)

            dom_item.setAttribute('data-value', dom_option.value)
            // dom_item.setAttribute('data-title', dom_option.innerHTML)
            dom_item.setAttribute('data-title', option_label)
            dom_item.setAttribute('data-description', option_description)
            dom_item.setAttribute('class', 'js-select-item')
            dom_item.innerHTML = option_label_html
            
            this.__init_dom_actions(dom_item, {
                'click': this.onSelectItem.bind(this, dom_item)
            })
            this.dom.list.appendChild(dom_item)
            this.items.push(dom_item)
        }
    }
    buildValue(options){
        const preserved_value = this.getValue()

        for(const dom_item of this.items){
            dom_item.remove()
        }
        this.items = []
        this.dom.select.innerHTML = ''
        for(const option of options){
            const dom_option = document.createElement('option')
            dom_option.innerHTML = option.label
            dom_option.value = option.value
            this.dom.select.appendChild(dom_option)
        }
        this.initOptions()
        this.selectFirstItem()
        this.resetSlideHeight()
        this.setValue(preserved_value)
    }
    onSelectItem(dom_item, event){
        this.selectItem(dom_item)
        this.dispatchEvent('changed')
        this.toggle(false)
    }
    selectItem(dom_item){
        const value = dom_item.getAttribute('data-value')
        this.setValue(value)
        // console.log(this.dom.select.value, value)
        this.setTitleFromSelect()
    }
    selectFirstItem(){
        if(this.items.length > 0){
            this.selectItem(this.items[0])
        }
    }
    setTitleFromSelect(){
        // console.log(this.dom.select?.selectedIndex, !!this.dom.select?.selectedIndex)
        if(
            this.dom.select?.selectedIndex !== null
            && this.dom.select?.selectedIndex >= 0
        ){
            // const title = this.dom.select
            //     .options[this.dom.select.selectedIndex].innerHTML
            const {
                label: title,
                description,
            } = this.prepareOptionLabel(
                this.dom.select
                    .options[this.dom.select.selectedIndex]
                    .innerHTML
                )
            this.dom.title_input.value = title
            this.dom.title.innerHTML = title

            this.option_description = description
        }
    }
    searchItems(){

        this.toggle(true)

        const search_value = this.dom.title_input.value

        const reg =  new RegExp(
            // search_value
                // .split(' ')
                // .join('|'),
                // .join('&'),
            search_value,
            'i'
        )

        // console.log(reg)

        for(const dom_item of this.items){
            const item_value = dom_item.getAttribute('data-title')
            // dom_item.classList.toggle('is--hidden', !search_substring(item_value, search_value) )
            dom_item.classList.toggle('is--hidden', !item_value.match(reg))
        }
        this.resetSlideHeight()
    }
    onToggle(event){
        this.toggle()
    }
    toggle(activate = null){
        NodeHelper.ToggleClass(this.node, 'is--active', activate)

        if(this.node.classList.contains('is--active')){
            this.focus()
        }
        this.resetSlideHeight()
    }
    resetSlideHeight(){
        const is_active = this.node.classList.contains('is--active')
        let height
        if(is_active){
            const rect = this.dom.list.getBoundingClientRect()
            height = rect.height
    
        }else{
            height = 0
        }
        this.dom.slide.style.height = `${height}px`;
    }
    getOptions(){
        return this.items.map((dom_item) => {
            return dom_item.getAttribute('data-value')
        })
    }
    changed(){
        this.dispatchEvent('changed')
    }
    isRequired(){
        return this.dom.select.hasAttribute('required')
    }
    isFilled(){
        return !!this.dom.select.dataset.value
    }
    getValue(){
        return _cast(this.dom.select.dataset.value)
    }
    getSelectedOptionData(){
        return {
            value: this.getValue(),
            label: this.dom.title.innerHTML.trim(),
            description: this.option_description
        }
    }
    setValue(value){
        // console.log('onAtomChange setValue', value, this.node, this.dom.select)
        // console.trace()
        // console.log('recomputed value', value)
        this.dom.select.dataset.value = value
        this.dom.select.value = value
        // console.log('onAtomChange dom.select', this.getOptions())
        if(
            this.dom.select?.selectedIndex === null
            || this.dom.select?.selectedIndex < 0
        ){
            this.selectFirstItem()
            if(!this.was_invalid){
                this.was_invalid = true
                this.dispatchEvent('invalid_rebuild')
                this.dispatchEvent('changed')
            }else{
                this.was_invalid = false
            }
        }
        this.setTitleFromSelect()
    }
    unfocus(){
        this.toggle(false)
    }
}

export default SelectField